import { z } from 'zod';
/**
 * Коды дополнительных услуг к поручению (`OrderExtraService.code`).
 *
 * Перечень зафиксирован для MVP и валидируется на уровне DTO. В Prisma-схеме
 * поле хранится как `String` — это сознательное решение (см. docs/architecture.md
 * раздел про коды услуг): даёт возможность безболезненно расширить набор без
 * миграции, валидация — за пределами БД, едиными правилами на api и web.
 */
export const extraServiceCodeSchema = z.enum([
    /** Страхование груза. */
    'INSURANCE',
    /** Таможенное оформление. */
    'CUSTOMS',
    /** Складская обработка / хранение. */
    'WAREHOUSE',
    /** Маркировка груза. */
    'MARKING',
    /** Упаковка / переупаковка. */
    'PACKAGING',
    /** Подготовка пакета документов. */
    'DOCS',
]);
/** Удобный массив всех допустимых кодов (для drop-down'ов в UI). */
export const EXTRA_SERVICE_CODES = extraServiceCodeSchema.options;
//# sourceMappingURL=extra-service.js.map